// SmartTableCard — غلاف Paper موحّد للجداول (حدّ + تمرير أفقي على ثيم SMART).
import React from 'react';
import { Paper } from '@mui/material';
import { SMART_COLORS as C } from '../../theme/smartStableTheme';

export default function SmartTableCard({ children, sx }) {
  return (
    <Paper variant="outlined" sx={{ borderColor: C.line, overflowX: 'auto', ...sx }}>
      {children}
    </Paper>
  );
}
